var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c("auto-number-input", {
        attrs: { precision: 3, min: 0, disabled: _vm.disabled },
        on: {
          change: function($event) {
            return _vm.onChange("cubageContract")
          }
        },
        model: {
          value: _vm.job.cubageContract,
          callback: function($$v) {
            _vm.$set(_vm.job, "cubageContract", $$v)
          },
          expression: "job.cubageContract"
        }
      }),
      _c("span", { staticStyle: { padding: "0 2px" } }, [_vm._v("/")]),
      _c("auto-number-input", {
        attrs: { precision: 3, disabled: _vm.disabled, min: 0 },
        on: {
          change: function($event) {
            return _vm.onChange("cubageActual")
          }
        },
        model: {
          value: _vm.job.cubageActual,
          callback: function($$v) {
            _vm.$set(_vm.job, "cubageActual", $$v)
          },
          expression: "job.cubageActual"
        }
      }),
      _c("span", { staticStyle: { "min-width": "50px" } }, [_vm._v("CBM")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }